// extracted by css-extract-rspack-plugin
export default {"docsLink":"pEwVVjf0SQFiOOej","statusCardColumn":"xxrywuTQgNgp72Yy","queuedCardButton":"JJ3c7sqxIAN169QM"};